export default {
    changePassword: 'Change Password',
    newPassword: 'New Password',
    save: 'Save',
    thisFieldIsRequired: 'This field is required',
    thisFieldIsExceededCharacters: 'This field is exceeded 255 characters',
    congratulation: 'Congratulation',
    errorMessage: 'Error Message',
    passwordOfUserIsUpdated: 'Password of user is updated'
}
